import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "row gx-5 gy-3 h-100",
  style: {"min-height":"400px"}
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass('col-12')
}
const _hoisted_3 = {
  key: 1,
  class: "h-100 d-flex align-items-center"
}
const _hoisted_4 = { class: "w-100 d-flex align-items-center justify-content-center" }
const _hoisted_5 = {
  key: 1,
  class: "card-body"
}
const _hoisted_6 = {
  key: 1,
  class: "card-body"
}
const _hoisted_7 = {
  key: 2,
  class: "card-body"
}
const _hoisted_8 = {
  key: 3,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FavoriteCategoriesList = _resolveComponent("FavoriteCategoriesList")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_LinkSecondary = _resolveComponent("LinkSecondary")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_Card = _resolveComponent("Card")!

  return (_ctx.isMobile)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        show: _ctx.mobileShow,
        title: _ctx.t('FavoriteCategoriesModalTitle'),
        xl: "",
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:mobileShow')))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.showAddBtn)
              ? (_openBlock(), _createBlock(_component_LinkSecondary, {
                  key: 0,
                  onClick: _withModifiers(_ctx.addCurrentCategory, ["prevent"]),
                  class: "ext-add"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      glyph: 'plus',
                      class: "me-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('FavoriteCategoriesAddCurrentCategory')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.showRemoveBtn)
              ? (_openBlock(), _createBlock(_component_LinkSecondary, {
                  key: 1,
                  onClick: _withModifiers(_ctx.removeCurrentCategory, ["prevent"]),
                  class: "ext-remove"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      glyph: 'close',
                      class: "me-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('FavoriteCategoriesRemoveCurrentCategory')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.categories?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.categories?.length)
                      ? (_openBlock(), _createBlock(_component_FavoriteCategoriesList, {
                          key: 0,
                          categories: _ctx.categories,
                          onClickItem: _ctx.setCategory,
                          onRemoveItem: _ctx.removeCategory
                        }, null, 8, ["categories", "onClickItem", "onRemoveItem"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Message, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('FavoriteCategoriesEmpty')), 1)
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ])
        ]),
        _: 1
      }, 8, ["show", "title"]))
    : (_openBlock(), _createBlock(_component_Card, {
        key: 1,
        class: "mb-4",
        icon: _ctx.componentOptions.icon && 'star',
        header: _ctx.t('FavoriteCategories'),
        "use-markup": _ctx.componentOptions.card,
        collapsed: _ctx.componentOptions.collapsed
      }, {
        list: _withCtx(() => [
          (_ctx.categories?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.categories?.length)
                  ? (_openBlock(), _createBlock(_component_FavoriteCategoriesList, {
                      key: 0,
                      categories: _ctx.categoriesTrimmed,
                      onClickItem: _ctx.setCategory,
                      onRemoveItem: _ctx.removeCategory
                    }, null, 8, ["categories", "onClickItem", "onRemoveItem"]))
                  : _createCommentVNode("", true),
                (_ctx.showMoreBtn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_LinkSecondary, {
                        onClick: _withModifiers(_ctx.showAllCategories, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Arrow, {
                            class: "me-2",
                            dir: _ctx.trimList ? 'down' : 'up'
                          }, null, 8, ["dir"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.trimList ? _ctx.t('ShowAllCategories') : _ctx.t('HideAllCategories')) + " (" + _toDisplayString(_ctx.categories.length) + ") ", 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_Message, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('FavoriteCategoriesEmpty')), 1)
                  ]),
                  _: 1
                })
              ])),
          (_ctx.showAddBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_LinkSecondary, {
                  onClick: _withModifiers(_ctx.addCurrentCategory, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      glyph: 'plus',
                      class: "me-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('FavoriteCategoriesAddCurrentCategory')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showRemoveBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_LinkSecondary, {
                  onClick: _withModifiers(_ctx.removeCurrentCategory, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      glyph: 'close',
                      class: "me-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('FavoriteCategoriesRemoveCurrentCategory')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["icon", "header", "use-markup", "collapsed"]))
}